import { VERSION_CUSTOMISED, VERSION_PRO, VERSION_STANDARD } from "@/components/getstart/constants";

export const listSwiperData = [
   {
      icon: "images/salebot_icon_01.webp",
      title: "EnsSalesBot",
      at: "@EnsSalesBot",
      info: "Hot Sales/Registrations of .eth ensdomains (0.5Ξ & above)",
      pic: "images/salebot_pic_01.webp",
      twitter_url: "https://twitter.com/EnsSalesBot",
   },
   {
      icon: "images/salebot_icon_17.webp",
      title: "ClonexSalesBot",
      at: "@ClonexSalesBots",
      info: "I tweet sales of CloneX & MINT VIAL & Large bids from all markets.",
      pic: "images/salebot_pic_17.webp",
      twitter_url: "https://twitter.com/ClonexSalesBots",
   },
   {
      icon: "images/salebot_icon_08.webp",
      title: "BAYCSalesBot",
      at: "@BAYCsalesbot",
      info: "I tweet all sales of @BoredApeYC from OpenSea/X2Y2/LooksRare/Blur etc.",
      pic: "images/salebot_pic_08.webp",
      twitter_url: "https://twitter.com/BAYCSalesBot",
   },
   {
      icon: "images/salebot_icon_09.webp",
      title: "AzukiSalesBot",
      at: "@AzukiBots",
      info: "I tweet All sales & Large bids of Azuki@AzukiOfficial. Also tweet sales of Beanz",
      pic: "images/salebot_pic_09.webp",
      twitter_url: "https://twitter.com/AzukiBots",
   },
   {
      icon: "images/salebot_icon_20.webp",
      title: "SappySealsSalesBot",
      at: "@SappySealsBots",
      info: "I tweet all sales of Sappy Seals @SappySealsNFT from all markets.",
      pic: "images/salebot_pic_20.webp",
      twitter_url: "https://twitter.com/SappySealsBots",
   },
];



var listWhatData = [
   {
      icon: "iconfont/icon_what_01.svg",
      title: "Fastest",
      info: "Sales data are scraped and posted within 30 seconds.",
   },
   {
      icon: "iconfont/icon_what_02.svg",
      title: "Most Comprehensive",
      info: "Sales data are acquired from all available NFT exchanges, marketplaces, aggregators. No missing data.",
   },
   {
      icon: "iconfont/icon_what_03.svg",
      title: "Multiple Tokens",
      info: "Prices listed in different tokens are all captured, i.e. ETH/WETH/USDC/APE, etc.",
   },
   {
      icon: "iconfont/icon_what_04.svg",
      title: "Customisable Display Mode",
      info: "AlohaBots support different ways of display of sales information, i.e. full NFT image, transaction links to marketplaces, etc.",
   },
   {
      icon: "iconfont/icon_what_05.svg",
      title: "Customisable Twitter & Discord Messages",
      info: "AlohaBots support customised posts’ contents, i.e. sales threshold, prefix, surfix, Twitter tags, emoji, etc. ",
   },
   {
      icon: "iconfont/icon_what_06.svg",
      title: "Customisable Sales Data Combination",
      info: "AlohaBots support sales data combination of 2-5 collections of an NFT project. ",
   },
   {
      icon: "iconfont/icon_what_07.svg",
      title: "Customisable Sales Data Acquisition",
      info: "AlohaBots support sales data acquisition of NFTs with certain specific attributes from one collection.",
   },
];
export function getAlohainfoWhatData() {
   return listWhatData;
}

var listSupportData = [
   {
      infolist: [
         "Fastest and most comprehensive",
         "Customised twitter message with prices listed in multiple tokens",
         "Display of full NFT image and direct link to transactions",
      ],
      bots: [
         {
            icon: "images/salebot_icon_08.webp",
            title: "BAYCSalesBot",
            pic: "images/salebot_pic_08.webp",
            twitter_url: "https://twitter.com/BAYCSalesBot",
         },
         {
            icon: "images/salebot_icon_17.webp",
            title: "ClonexSalesBots",
            pic: "images/salebot_pic_17.webp",
            twitter_url: "https://twitter.com/ClonexSalesBots",
         },
      ],
   },
   {
      infolist: [
         "Fastest and most comprehensive",
         "Multiple display mode with two types of NFT images",
         "Customised sales data acquisition of Koda & Azuki collections with specific attributes",
      ],
      bots: [
         {
            icon: "images/salebot_icon_03.webp",
            title: "KodaSalesBot",
            pic: "images/salebot_pic_03.webp",
            twitter_url: "https://twitter.com/KodaSalesBot",
         },
         {
            icon: "images/salebot_icon_12.webp",
            title: "SpiritAzukiBot",
            pic: "images/salebot_pic_12.webp",
            twitter_url: "https://twitter.com/SpiritAzukiBot",
         },
      ],
   },
   {
      infolist: [
         "Fastest and most comprehensive",
         "Display of exclusively designed image and link to different NFT marketplaces",
         "Customised sales data combination from multiple sources",
      ],
      bots: [
         {
            icon: "images/salebot_icon_01.webp",
            title: "EnsSalesBot",
            pic: "images/salebot_pic_01.webp",
            twitter_url: "https://twitter.com/EnsSalesBot",
         },
         {
            icon: "images/salebot_icon_05.webp",
            title: "The999ClubBot",
            pic: "images/salebot_pic_05.webp",
            twitter_url: "https://twitter.com/The999Bot",
         },
      ],
   }
 
];
export function getAlohaSupportData() {
   return listSupportData;
}

export const listWhyData = [
   "Most new NFT projects face the problem of low community engagement. Community members have difficulties spreading the latest sales of projects.",
   "All successful NFT projects make good use of their own sales bots on Twitter, including BAYC.",
   "Sales bots available in the market are not satisfactory, yet developing your own sales bot requires large amount of resources.",
];

export const listHowData = [
   "Existing sales bots in the market are slow when capturing sales with missing data from time to time. AlohaBots surpasses them by providing the most timely and comprehensive transaction data.",
   "Being fast and trustworthy are not enough, AlohaBots also offers extensive intellectualisations and customisations.",
   "AlohaBots is not only easy to use, it also goes above-and-beyond expectations.",
];

export const listPriceList = [
   {
      type: VERSION_STANDARD,
      info: "The fastest and easiest way to get your very own bots",
      price: "1",
      list: [
         { type: "string", info: "Support 2 different smart contracts" },
         { type: "string", info: "Check for Sales:30 seconds" },
         { type: "string", info: "Price Data in Multiple Tokens:" },
         { type: "radio", list: ["ETH", "WETH", "USDC", "APE", "..."] },
         { type: "string", info: "Customisable Sales Price Threshold" },
         { type: "string", info: "Customisable Twitter Messages" },
         { type: "radio", list: ["Prefix, Surfix, Twitter tags, Emoji, etc"] },
         { type: "string", info: "Customisable Discord Messages" },
         { type: "radio", list: ["Bot name, Bot avatar, Image size, etc"] },
         { type: "string", info: "Customisable Display Mode" },
         { type: "radio", list: ["Full NFT Image", "Image format conversion", "Direct links to transactions"] },
         { type: "string", info: "Customisable Sales Data Combination" },
         { type: "radio", list: ["Data combination from multiple collections"] },
         { type: "string", info: "Data Sources:" },
         { type: "radio", list: ["Opensea", "Blur","MagicEden", "Looksrare", "X2Y2"] },
      ],
   },
   {
      type: VERSION_PRO,
      info: "More power to grow and engage community for NFT projects",
      price: "3",
      list: [
         { type: "string", info: "Support 5 different smart contracts" },
         { type: "string", info: "Check for Sales:30 seconds" },
         { type: "string", info: "Price Data in Multiple Tokens:" },
         { type: "radio", list: ["ETH", "WETH", "USDC", "APE", "..."] },
         { type: "string", info: "Customisable Sales Price Threshold" },
         { type: "string", info: "Customisable Twitter Messages" },
         { type: "radio", list: ["Prefix, Surfix, Twitter tags, Emoji, etc"] },
         { type: "string", info: "Customisable Discord Messages" },
         { type: "radio", list: ["Bot name, Bot avatar, Image size, etc"] },
         { type: "string", info: "Customisable Display Mode" },
         { type: "radio", list: ["Full NFT Image", "Image format conversion", "Direct links to transactions"] },
         { type: "string", info: "Customisable Sales Data Combination" },
         { type: "radio", list: ["Data combination from multiple collections"] },
         { type: "string", info: "Most Comprehensive Data Sources:" },
         { type: "radio", list: ["Opensea", "Blur","MagicEden", "Looksrare", "X2Y2", "Gem", "BendDao", "NFTtrader", "SudoSwap","Uniswap"] },
         { type: "string", info: "Report function" },
         { type: "string", info: "Bids push" },
      ],
   },
   {
      type: VERSION_CUSTOMISED,
      info: "All flexibility to meet your requirements and all the power to match the community growth",
      price: "5",
      tag: "All the goodness of Pro Version, and:",
      list: [
         { type: "string", info: "Customisable display of exclusively designed NFT image" },
         { type: "string", info: "Sales data from any other marketplaces" },
         { type: "string", info: "Sales data from any other smart contracts" },
         { type: "string", info: "Sales data of NFT with specific attributes from a collection" },
         { type: "string", info: "Other customisations as required" },
      ],
   },
];
